<div class="top-menu">
  <div class="logo-wrap"></div>
  <div class="account-name hide-handheld">
    {{ userLabel.email || userLabel.name || 'Unknown' }}
  </div>
</div>
